import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'dpqa-beta-tool',
  imports: [
    TranslatePipe,
    NzTooltipModule,
  ],
  templateUrl: './beta-tool.component.html',
  styleUrls: ['./beta-tool.component.less'],
})
export class BetaToolComponent {

}
